function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP confirm email
 * 
 */
import React from 'react';
import { connect } from 'react-redux';
import { confirmEmail } from '../../actions/index';
import TextInput from '../text-input/TextInput';
import { FIELDS } from '../../data/Data';
import './ConfirmEmail.scss';
import { jsx as _jsx } from "react/jsx-runtime";
export class ConfirmEmail extends React.Component {
  render() {
    const {
      confirmEmail,
      setConfirmEmail
    } = this.props;
    return /*#__PURE__*/_jsx(TextInput, {
      autoComplete: "email",
      handleChange: setConfirmEmail,
      onBlur: setConfirmEmail,
      label: "Confirm email",
      name: "confirmEmail",
      section: "personal-details"
      // $FlowFixMe
      ,
      values: {
        confirmEmail
      },
      type: "email",
      inputMode: "email"
    });
  }
}
_defineProperty(ConfirmEmail, "defaultProps", {
  confirmEmail: {
    ...FIELDS.confirmEmail
  }
});
const mapStateToProps = ({
  confirmEmail
}) => {
  return {
    confirmEmail
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setConfirmEmail: value => {
      dispatch(confirmEmail(value));
    }
  };
};
const VisibleConfirmEmail = connect(mapStateToProps, mapDispatchToProps)(ConfirmEmail);
export default VisibleConfirmEmail;